document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".toggle-logos");

  toggleButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const slide = button.closest(".swiper-slide");
      const logoElements = slide.querySelectorAll(
        ".left_logo_with_text .logo_with_text:nth-child(n+4)"
      );

      const isExpanded = button.getAttribute("aria-expanded") === "true";
      logoElements.forEach((logo) => {
        if (isExpanded) {
          logo.classList.remove("show");
        } else {
          logo.classList.add("show");
        }
      });

      const span = button.querySelector("span");
      span.textContent = isExpanded ? "+" : "+";
      button.setAttribute("aria-expanded", !isExpanded);
    });
  });


  var swiper = new Swiper(".ctm_pdpimage_gridslider", {
    slidesPerView: 6,
    loop:false,
    centeredSlides: false,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 6,
      },
      414: {
        slidesPerView: 2.5,
         loop:true,
          centeredSlides: true,
      },
      320: {
        slidesPerView: 2.5,
        loop:true,
          centeredSlides: true,
      },
    },
  
  }); 
  
});
